import RichTextWPViewer from "@components/RichTextWPViewer";
import React, { useEffect, useState } from "react";

import styles from './ProductOverviewDescription.module.scss';

const ProductOverviewDescription = ({ content, index }) => {
  const [height, setHeight] = useState("auto");
  const [showBtnReadMore, setShowBtnReadMore] = useState(false);
  const id = "ProductOverviewDescription_" + index;
  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }
    const contentHeight = document.getElementById(id).clientHeight;
    
    if (contentHeight > 372) {
      setHeight(372);
      setShowBtnReadMore(true);
    }
  }, []);

  const handleClickBtnReadMore = () => {
    setHeight("auto");
    setShowBtnReadMore(false);
  };
  return (
    <div className={styles["vnr-comp-ProductOverviewDescription"]}>
      <div id={id} style={{ height: height, overflow: "hidden" }}>
        <RichTextWPViewer content={content} />
      </div>
      {showBtnReadMore && (
        <div className={styles["vnr-btn-read-more-container"]}>
          <button onClick={handleClickBtnReadMore}>
            <div className={styles.viewMore}>&#187; Xem đầy đủ</div>
          </button>
        </div>
      )}
    </div>
  );
};

export default ProductOverviewDescription;
